// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=js"
// @generated from file console/admin/v1/legal.proto (package console.admin.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { LegalBlock } from "../../common/v1/common_pb.js";
import { file_console_common_v1_common } from "../../common/v1/common_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file console/admin/v1/legal.proto.
 */
export const file_console_admin_v1_legal: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_console_common_v1_common]);

/**
 * @generated from message console.admin.v1.LegalVersion
 */
export type LegalVersion = Message<"console.admin.v1.LegalVersion"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;

  /**
   * 1, 2, ...; a draft has the number it will be published as.
   *
   * @generated from field: uint32 version = 3;
   */
  version: number;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: string body_markdown = 5;
   */
  bodyMarkdown: string;

  /**
   * @generated from field: repeated console.common.v1.LegalBlock blocks = 6;
   */
  blocks: LegalBlock[];

  /**
   * Hex sha256 of `body_markdown`; empty on a draft.
   *
   * @generated from field: string body_sha256 = 7;
   */
  bodySha256: string;

  /**
   * @generated from field: string change_summary = 8;
   */
  changeSummary: string;

  /**
   * `draft` or `published`.
   *
   * @generated from field: string status = 9;
   */
  status: string;

  /**
   * @generated from field: bool requires_reacceptance = 10;
   */
  requiresReacceptance: boolean;

  /**
   * When it is asked from; absent when from publication.
   *
   * @generated from field: google.protobuf.Timestamp effective_at = 11;
   */
  effectiveAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp published_at = 12;
   */
  publishedAt?: Timestamp | undefined;

  /**
   * @generated from field: string published_by_name = 13;
   */
  publishedByName: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message console.admin.v1.LegalVersion.
 * Use `create(LegalVersionSchema)` to create a new message.
 */
export const LegalVersionSchema: GenMessage<LegalVersion> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 0);

/**
 * @generated from message console.admin.v1.LegalDocumentSummary
 */
export type LegalDocumentSummary = Message<"console.admin.v1.LegalDocumentSummary"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * The title of the version in effect, else of the draft.
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * `active` or `retired`.
   *
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * The version people read now. Absent before the first is in effect.
   *
   * @generated from field: console.admin.v1.LegalVersion in_effect = 5;
   */
  inEffect?: LegalVersion | undefined;

  /**
   * The version people must have accepted, this one or a later one. Absent
   * before the first is in effect.
   *
   * @generated from field: uint32 required_version = 6;
   */
  requiredVersion: number;

  /**
   * Published with an effective date still to come.
   *
   * @generated from field: console.admin.v1.LegalVersion scheduled = 7;
   */
  scheduled?: LegalVersion | undefined;

  /**
   * Staff only.
   *
   * @generated from field: console.admin.v1.LegalVersion draft = 8;
   */
  draft?: LegalVersion | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message console.admin.v1.LegalDocumentSummary.
 * Use `create(LegalDocumentSummarySchema)` to create a new message.
 */
export const LegalDocumentSummarySchema: GenMessage<LegalDocumentSummary> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 1);

/**
 * @generated from message console.admin.v1.ListLegalDocumentsRequest
 */
export type ListLegalDocumentsRequest = Message<"console.admin.v1.ListLegalDocumentsRequest"> & {
};

/**
 * Describes the message console.admin.v1.ListLegalDocumentsRequest.
 * Use `create(ListLegalDocumentsRequestSchema)` to create a new message.
 */
export const ListLegalDocumentsRequestSchema: GenMessage<ListLegalDocumentsRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 2);

/**
 * @generated from message console.admin.v1.ListLegalDocumentsResponse
 */
export type ListLegalDocumentsResponse = Message<"console.admin.v1.ListLegalDocumentsResponse"> & {
  /**
   * @generated from field: repeated console.admin.v1.LegalDocumentSummary documents = 1;
   */
  documents: LegalDocumentSummary[];
};

/**
 * Describes the message console.admin.v1.ListLegalDocumentsResponse.
 * Use `create(ListLegalDocumentsResponseSchema)` to create a new message.
 */
export const ListLegalDocumentsResponseSchema: GenMessage<ListLegalDocumentsResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 3);

/**
 * @generated from message console.admin.v1.GetLegalDocumentRequest
 */
export type GetLegalDocumentRequest = Message<"console.admin.v1.GetLegalDocumentRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;
};

/**
 * Describes the message console.admin.v1.GetLegalDocumentRequest.
 * Use `create(GetLegalDocumentRequestSchema)` to create a new message.
 */
export const GetLegalDocumentRequestSchema: GenMessage<GetLegalDocumentRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 4);

/**
 * @generated from message console.admin.v1.GetLegalDocumentResponse
 */
export type GetLegalDocumentResponse = Message<"console.admin.v1.GetLegalDocumentResponse"> & {
  /**
   * @generated from field: console.admin.v1.LegalDocumentSummary document = 1;
   */
  document?: LegalDocumentSummary | undefined;

  /**
   * Newest first; a draft only for staff.
   *
   * @generated from field: repeated console.admin.v1.LegalVersion versions = 2;
   */
  versions: LegalVersion[];
};

/**
 * Describes the message console.admin.v1.GetLegalDocumentResponse.
 * Use `create(GetLegalDocumentResponseSchema)` to create a new message.
 */
export const GetLegalDocumentResponseSchema: GenMessage<GetLegalDocumentResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 5);

/**
 * @generated from message console.admin.v1.CreateLegalDocumentRequest
 */
export type CreateLegalDocumentRequest = Message<"console.admin.v1.CreateLegalDocumentRequest"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;
};

/**
 * Describes the message console.admin.v1.CreateLegalDocumentRequest.
 * Use `create(CreateLegalDocumentRequestSchema)` to create a new message.
 */
export const CreateLegalDocumentRequestSchema: GenMessage<CreateLegalDocumentRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 6);

/**
 * @generated from message console.admin.v1.CreateLegalDocumentResponse
 */
export type CreateLegalDocumentResponse = Message<"console.admin.v1.CreateLegalDocumentResponse"> & {
  /**
   * @generated from field: console.admin.v1.LegalDocumentSummary document = 1;
   */
  document?: LegalDocumentSummary | undefined;
};

/**
 * Describes the message console.admin.v1.CreateLegalDocumentResponse.
 * Use `create(CreateLegalDocumentResponseSchema)` to create a new message.
 */
export const CreateLegalDocumentResponseSchema: GenMessage<CreateLegalDocumentResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 7);

/**
 * @generated from message console.admin.v1.SaveLegalDraftRequest
 */
export type SaveLegalDraftRequest = Message<"console.admin.v1.SaveLegalDraftRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string body_markdown = 3;
   */
  bodyMarkdown: string;

  /**
   * What changed, shown to people who accepted an earlier version.
   *
   * @generated from field: string change_summary = 4;
   */
  changeSummary: string;
};

/**
 * Describes the message console.admin.v1.SaveLegalDraftRequest.
 * Use `create(SaveLegalDraftRequestSchema)` to create a new message.
 */
export const SaveLegalDraftRequestSchema: GenMessage<SaveLegalDraftRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 8);

/**
 * @generated from message console.admin.v1.SaveLegalDraftResponse
 */
export type SaveLegalDraftResponse = Message<"console.admin.v1.SaveLegalDraftResponse"> & {
  /**
   * @generated from field: console.admin.v1.LegalVersion draft = 1;
   */
  draft?: LegalVersion | undefined;
};

/**
 * Describes the message console.admin.v1.SaveLegalDraftResponse.
 * Use `create(SaveLegalDraftResponseSchema)` to create a new message.
 */
export const SaveLegalDraftResponseSchema: GenMessage<SaveLegalDraftResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 9);

/**
 * @generated from message console.admin.v1.DeleteLegalDraftRequest
 */
export type DeleteLegalDraftRequest = Message<"console.admin.v1.DeleteLegalDraftRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;
};

/**
 * Describes the message console.admin.v1.DeleteLegalDraftRequest.
 * Use `create(DeleteLegalDraftRequestSchema)` to create a new message.
 */
export const DeleteLegalDraftRequestSchema: GenMessage<DeleteLegalDraftRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 10);

/**
 * @generated from message console.admin.v1.DeleteLegalDraftResponse
 */
export type DeleteLegalDraftResponse = Message<"console.admin.v1.DeleteLegalDraftResponse"> & {
};

/**
 * Describes the message console.admin.v1.DeleteLegalDraftResponse.
 * Use `create(DeleteLegalDraftResponseSchema)` to create a new message.
 */
export const DeleteLegalDraftResponseSchema: GenMessage<DeleteLegalDraftResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 11);

/**
 * @generated from message console.admin.v1.PreviewLegalMarkdownRequest
 */
export type PreviewLegalMarkdownRequest = Message<"console.admin.v1.PreviewLegalMarkdownRequest"> & {
  /**
   * @generated from field: string body_markdown = 1;
   */
  bodyMarkdown: string;
};

/**
 * Describes the message console.admin.v1.PreviewLegalMarkdownRequest.
 * Use `create(PreviewLegalMarkdownRequestSchema)` to create a new message.
 */
export const PreviewLegalMarkdownRequestSchema: GenMessage<PreviewLegalMarkdownRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 12);

/**
 * @generated from message console.admin.v1.PreviewLegalMarkdownResponse
 */
export type PreviewLegalMarkdownResponse = Message<"console.admin.v1.PreviewLegalMarkdownResponse"> & {
  /**
   * @generated from field: repeated console.common.v1.LegalBlock blocks = 1;
   */
  blocks: LegalBlock[];

  /**
   * Empty when the Markdown is fine; else the first thing the console cannot
   * draw, with its line.
   *
   * @generated from field: string problem = 2;
   */
  problem: string;
};

/**
 * Describes the message console.admin.v1.PreviewLegalMarkdownResponse.
 * Use `create(PreviewLegalMarkdownResponseSchema)` to create a new message.
 */
export const PreviewLegalMarkdownResponseSchema: GenMessage<PreviewLegalMarkdownResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 13);

/**
 * @generated from message console.admin.v1.PreviewLegalPublishRequest
 */
export type PreviewLegalPublishRequest = Message<"console.admin.v1.PreviewLegalPublishRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: bool requires_reacceptance = 2;
   */
  requiresReacceptance: boolean;
};

/**
 * Describes the message console.admin.v1.PreviewLegalPublishRequest.
 * Use `create(PreviewLegalPublishRequestSchema)` to create a new message.
 */
export const PreviewLegalPublishRequestSchema: GenMessage<PreviewLegalPublishRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 14);

/**
 * @generated from message console.admin.v1.PreviewLegalPublishResponse
 */
export type PreviewLegalPublishResponse = Message<"console.admin.v1.PreviewLegalPublishResponse"> & {
  /**
   * People who would be asked at their next full sign-in.
   *
   * @generated from field: uint32 asked = 1;
   */
  asked: number;

  /**
   * Everyone who can sign in, covered or not.
   *
   * @generated from field: uint32 people = 2;
   */
  people: number;

  /**
   * People whose organization's agreement covers them.
   *
   * @generated from field: uint32 covered = 3;
   */
  covered: number;

  /**
   * Whether this would be the first version, which always asks.
   *
   * @generated from field: bool first_version = 4;
   */
  firstVersion: boolean;
};

/**
 * Describes the message console.admin.v1.PreviewLegalPublishResponse.
 * Use `create(PreviewLegalPublishResponseSchema)` to create a new message.
 */
export const PreviewLegalPublishResponseSchema: GenMessage<PreviewLegalPublishResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 15);

/**
 * @generated from message console.admin.v1.PublishLegalVersionRequest
 */
export type PublishLegalVersionRequest = Message<"console.admin.v1.PublishLegalVersionRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: bool requires_reacceptance = 2;
   */
  requiresReacceptance: boolean;

  /**
   * Absent: in effect at once. Otherwise asked from then.
   *
   * @generated from field: google.protobuf.Timestamp effective_at = 3;
   */
  effectiveAt?: Timestamp | undefined;
};

/**
 * Describes the message console.admin.v1.PublishLegalVersionRequest.
 * Use `create(PublishLegalVersionRequestSchema)` to create a new message.
 */
export const PublishLegalVersionRequestSchema: GenMessage<PublishLegalVersionRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 16);

/**
 * @generated from message console.admin.v1.PublishLegalVersionResponse
 */
export type PublishLegalVersionResponse = Message<"console.admin.v1.PublishLegalVersionResponse"> & {
  /**
   * @generated from field: console.admin.v1.LegalVersion version = 1;
   */
  version?: LegalVersion | undefined;
};

/**
 * Describes the message console.admin.v1.PublishLegalVersionResponse.
 * Use `create(PublishLegalVersionResponseSchema)` to create a new message.
 */
export const PublishLegalVersionResponseSchema: GenMessage<PublishLegalVersionResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 17);

/**
 * @generated from message console.admin.v1.RetireLegalDocumentRequest
 */
export type RetireLegalDocumentRequest = Message<"console.admin.v1.RetireLegalDocumentRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;
};

/**
 * Describes the message console.admin.v1.RetireLegalDocumentRequest.
 * Use `create(RetireLegalDocumentRequestSchema)` to create a new message.
 */
export const RetireLegalDocumentRequestSchema: GenMessage<RetireLegalDocumentRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 18);

/**
 * @generated from message console.admin.v1.RetireLegalDocumentResponse
 */
export type RetireLegalDocumentResponse = Message<"console.admin.v1.RetireLegalDocumentResponse"> & {
};

/**
 * Describes the message console.admin.v1.RetireLegalDocumentResponse.
 * Use `create(RetireLegalDocumentResponseSchema)` to create a new message.
 */
export const RetireLegalDocumentResponseSchema: GenMessage<RetireLegalDocumentResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 19);

/**
 * @generated from message console.admin.v1.DeleteLegalDocumentRequest
 */
export type DeleteLegalDocumentRequest = Message<"console.admin.v1.DeleteLegalDocumentRequest"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: string confirm_key = 2;
   */
  confirmKey: string;
};

/**
 * Describes the message console.admin.v1.DeleteLegalDocumentRequest.
 * Use `create(DeleteLegalDocumentRequestSchema)` to create a new message.
 */
export const DeleteLegalDocumentRequestSchema: GenMessage<DeleteLegalDocumentRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 20);

/**
 * @generated from message console.admin.v1.DeleteLegalDocumentResponse
 */
export type DeleteLegalDocumentResponse = Message<"console.admin.v1.DeleteLegalDocumentResponse"> & {
};

/**
 * Describes the message console.admin.v1.DeleteLegalDocumentResponse.
 * Use `create(DeleteLegalDocumentResponseSchema)` to create a new message.
 */
export const DeleteLegalDocumentResponseSchema: GenMessage<DeleteLegalDocumentResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 21);

/**
 * @generated from message console.admin.v1.OrgAgreement
 */
export type OrgAgreement = Message<"console.admin.v1.OrgAgreement"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string;

  /**
   * For example "Master Services Agreement, 2026-08-14".
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string body_markdown = 4;
   */
  bodyMarkdown: string;

  /**
   * @generated from field: repeated console.common.v1.LegalBlock blocks = 5;
   */
  blocks: LegalBlock[];

  /**
   * @generated from field: string body_sha256 = 6;
   */
  bodySha256: string;

  /**
   * The day the contract took effect.
   *
   * @generated from field: google.protobuf.Timestamp covers_from = 7;
   */
  coversFrom?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp set_at = 8;
   */
  setAt?: Timestamp | undefined;

  /**
   * @generated from field: string set_by_name = 9;
   */
  setByName: string;

  /**
   * Absent while it stands.
   *
   * @generated from field: google.protobuf.Timestamp cleared_at = 10;
   */
  clearedAt?: Timestamp | undefined;

  /**
   * @generated from field: string cleared_by_name = 11;
   */
  clearedByName: string;

  /**
   * `replaced` or `cleared`; empty while it stands.
   *
   * @generated from field: string ended = 12;
   */
  ended: string;
};

/**
 * Describes the message console.admin.v1.OrgAgreement.
 * Use `create(OrgAgreementSchema)` to create a new message.
 */
export const OrgAgreementSchema: GenMessage<OrgAgreement> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 22);

/**
 * @generated from message console.admin.v1.GetOrgAgreementRequest
 */
export type GetOrgAgreementRequest = Message<"console.admin.v1.GetOrgAgreementRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;
};

/**
 * Describes the message console.admin.v1.GetOrgAgreementRequest.
 * Use `create(GetOrgAgreementRequestSchema)` to create a new message.
 */
export const GetOrgAgreementRequestSchema: GenMessage<GetOrgAgreementRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 23);

/**
 * @generated from message console.admin.v1.GetOrgAgreementResponse
 */
export type GetOrgAgreementResponse = Message<"console.admin.v1.GetOrgAgreementResponse"> & {
  /**
   * Absent when the organization has none.
   *
   * @generated from field: console.admin.v1.OrgAgreement current = 1;
   */
  current?: OrgAgreement | undefined;

  /**
   * Earlier ones, newest first.
   *
   * @generated from field: repeated console.admin.v1.OrgAgreement history = 2;
   */
  history: OrgAgreement[];
};

/**
 * Describes the message console.admin.v1.GetOrgAgreementResponse.
 * Use `create(GetOrgAgreementResponseSchema)` to create a new message.
 */
export const GetOrgAgreementResponseSchema: GenMessage<GetOrgAgreementResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 24);

/**
 * @generated from message console.admin.v1.SetOrgAgreementRequest
 */
export type SetOrgAgreementRequest = Message<"console.admin.v1.SetOrgAgreementRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string body_markdown = 3;
   */
  bodyMarkdown: string;

  /**
   * @generated from field: google.protobuf.Timestamp covers_from = 4;
   */
  coversFrom?: Timestamp | undefined;
};

/**
 * Describes the message console.admin.v1.SetOrgAgreementRequest.
 * Use `create(SetOrgAgreementRequestSchema)` to create a new message.
 */
export const SetOrgAgreementRequestSchema: GenMessage<SetOrgAgreementRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 25);

/**
 * @generated from message console.admin.v1.SetOrgAgreementResponse
 */
export type SetOrgAgreementResponse = Message<"console.admin.v1.SetOrgAgreementResponse"> & {
  /**
   * @generated from field: console.admin.v1.OrgAgreement agreement = 1;
   */
  agreement?: OrgAgreement | undefined;
};

/**
 * Describes the message console.admin.v1.SetOrgAgreementResponse.
 * Use `create(SetOrgAgreementResponseSchema)` to create a new message.
 */
export const SetOrgAgreementResponseSchema: GenMessage<SetOrgAgreementResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 26);

/**
 * @generated from message console.admin.v1.PreviewOrgAgreementClearRequest
 */
export type PreviewOrgAgreementClearRequest = Message<"console.admin.v1.PreviewOrgAgreementClearRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;
};

/**
 * Describes the message console.admin.v1.PreviewOrgAgreementClearRequest.
 * Use `create(PreviewOrgAgreementClearRequestSchema)` to create a new message.
 */
export const PreviewOrgAgreementClearRequestSchema: GenMessage<PreviewOrgAgreementClearRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 27);

/**
 * @generated from message console.admin.v1.PreviewOrgAgreementClearResponse
 */
export type PreviewOrgAgreementClearResponse = Message<"console.admin.v1.PreviewOrgAgreementClearResponse"> & {
  /**
   * People who would be asked at their next full sign-in.
   *
   * @generated from field: uint32 asked = 1;
   */
  asked: number;

  /**
   * Everyone in the organization who can sign in.
   *
   * @generated from field: uint32 people = 2;
   */
  people: number;
};

/**
 * Describes the message console.admin.v1.PreviewOrgAgreementClearResponse.
 * Use `create(PreviewOrgAgreementClearResponseSchema)` to create a new message.
 */
export const PreviewOrgAgreementClearResponseSchema: GenMessage<PreviewOrgAgreementClearResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 28);

/**
 * @generated from message console.admin.v1.ClearOrgAgreementRequest
 */
export type ClearOrgAgreementRequest = Message<"console.admin.v1.ClearOrgAgreementRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;
};

/**
 * Describes the message console.admin.v1.ClearOrgAgreementRequest.
 * Use `create(ClearOrgAgreementRequestSchema)` to create a new message.
 */
export const ClearOrgAgreementRequestSchema: GenMessage<ClearOrgAgreementRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 29);

/**
 * @generated from message console.admin.v1.ClearOrgAgreementResponse
 */
export type ClearOrgAgreementResponse = Message<"console.admin.v1.ClearOrgAgreementResponse"> & {
};

/**
 * Describes the message console.admin.v1.ClearOrgAgreementResponse.
 * Use `create(ClearOrgAgreementResponseSchema)` to create a new message.
 */
export const ClearOrgAgreementResponseSchema: GenMessage<ClearOrgAgreementResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 30);

/**
 * @generated from message console.admin.v1.LegalAcceptance
 */
export type LegalAcceptance = Message<"console.admin.v1.LegalAcceptance"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * The version accepted last.
   *
   * @generated from field: uint32 version = 2;
   */
  version: number;

  /**
   * @generated from field: google.protobuf.Timestamp accepted_at = 3;
   */
  acceptedAt?: Timestamp | undefined;

  /**
   * `device` or `console`.
   *
   * @generated from field: string surface = 4;
   */
  surface: string;

  /**
   * Meets the document's required version.
   *
   * @generated from field: bool current = 5;
   */
  current: boolean;
};

/**
 * Describes the message console.admin.v1.LegalAcceptance.
 * Use `create(LegalAcceptanceSchema)` to create a new message.
 */
export const LegalAcceptanceSchema: GenMessage<LegalAcceptance> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 31);

/**
 * @generated from message console.admin.v1.LegalStanding
 */
export type LegalStanding = Message<"console.admin.v1.LegalStanding"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * One per document in effect that the person has accepted any version of.
   *
   * @generated from field: repeated console.admin.v1.LegalAcceptance acceptances = 4;
   */
  acceptances: LegalAcceptance[];

  /**
   * Documents in effect the person has still to accept at their next full
   * sign-in, by id. Empty when covered.
   *
   * @generated from field: repeated string outstanding_document_ids = 5;
   */
  outstandingDocumentIds: string[];
};

/**
 * Describes the message console.admin.v1.LegalStanding.
 * Use `create(LegalStandingSchema)` to create a new message.
 */
export const LegalStandingSchema: GenMessage<LegalStanding> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 32);

/**
 * @generated from message console.admin.v1.ListLegalStandingRequest
 */
export type ListLegalStandingRequest = Message<"console.admin.v1.ListLegalStandingRequest"> & {
  /**
   * Org admins: their own (may be empty). Staff: required.
   *
   * @generated from field: string org_id = 1;
   */
  orgId: string;
};

/**
 * Describes the message console.admin.v1.ListLegalStandingRequest.
 * Use `create(ListLegalStandingRequestSchema)` to create a new message.
 */
export const ListLegalStandingRequestSchema: GenMessage<ListLegalStandingRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 33);

/**
 * @generated from message console.admin.v1.ListLegalStandingResponse
 */
export type ListLegalStandingResponse = Message<"console.admin.v1.ListLegalStandingResponse"> & {
  /**
   * Documents in effect, in the order a sign-in shows them.
   *
   * @generated from field: repeated console.admin.v1.LegalDocumentSummary documents = 1;
   */
  documents: LegalDocumentSummary[];

  /**
   * When set, nobody in the organization is asked.
   *
   * @generated from field: console.admin.v1.OrgAgreement agreement = 2;
   */
  agreement?: OrgAgreement | undefined;

  /**
   * @generated from field: repeated console.admin.v1.LegalStanding people = 3;
   */
  people: LegalStanding[];
};

/**
 * Describes the message console.admin.v1.ListLegalStandingResponse.
 * Use `create(ListLegalStandingResponseSchema)` to create a new message.
 */
export const ListLegalStandingResponseSchema: GenMessage<ListLegalStandingResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 34);

/**
 * @generated from message console.admin.v1.GetMyLegalDocumentsRequest
 */
export type GetMyLegalDocumentsRequest = Message<"console.admin.v1.GetMyLegalDocumentsRequest"> & {
};

/**
 * Describes the message console.admin.v1.GetMyLegalDocumentsRequest.
 * Use `create(GetMyLegalDocumentsRequestSchema)` to create a new message.
 */
export const GetMyLegalDocumentsRequestSchema: GenMessage<GetMyLegalDocumentsRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 35);

/**
 * @generated from message console.admin.v1.MyLegalDocument
 */
export type MyLegalDocument = Message<"console.admin.v1.MyLegalDocument"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * `active` or `retired`.
   *
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * What people read now. Absent for a retired document.
   *
   * @generated from field: console.admin.v1.LegalVersion in_effect = 4;
   */
  inEffect?: LegalVersion | undefined;

  /**
   * The version the person accepted last, with its text. Absent when they
   * have accepted none.
   *
   * @generated from field: console.admin.v1.LegalVersion accepted = 5;
   */
  accepted?: LegalVersion | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp accepted_at = 6;
   */
  acceptedAt?: Timestamp | undefined;

  /**
   * `device` or `console`.
   *
   * @generated from field: string accepted_on = 7;
   */
  acceptedOn: string;

  /**
   * What they accepted meets what is asked now, so they are not asked again.
   *
   * @generated from field: bool current = 8;
   */
  current: boolean;
};

/**
 * Describes the message console.admin.v1.MyLegalDocument.
 * Use `create(MyLegalDocumentSchema)` to create a new message.
 */
export const MyLegalDocumentSchema: GenMessage<MyLegalDocument> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 36);

/**
 * @generated from message console.admin.v1.GetMyLegalDocumentsResponse
 */
export type GetMyLegalDocumentsResponse = Message<"console.admin.v1.GetMyLegalDocumentsResponse"> & {
  /**
   * Documents in effect, then retired ones the person accepted.
   *
   * @generated from field: repeated console.admin.v1.MyLegalDocument documents = 1;
   */
  documents: MyLegalDocument[];

  /**
   * When set, the person's organization's agreement covers them and nothing is asked.
   *
   * @generated from field: console.admin.v1.OrgAgreement agreement = 2;
   */
  agreement?: OrgAgreement | undefined;
};

/**
 * Describes the message console.admin.v1.GetMyLegalDocumentsResponse.
 * Use `create(GetMyLegalDocumentsResponseSchema)` to create a new message.
 */
export const GetMyLegalDocumentsResponseSchema: GenMessage<GetMyLegalDocumentsResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_legal, 37);

/**
 * MotionSafe's legal documents, the versions people accept, and the custom
 * agreements that stand in for an organization's people (ARCHITECTURE.md
 * §16). Writing documents is a MotionSafe admin's alone; recording and
 * clearing an organization's agreement is also the Accounts staff role's.
 * Every member of staff reads; an organization's administrator reads the
 * published documents, their own organization's agreement, and their own
 * people's standing.
 *
 * @generated from service console.admin.v1.LegalService
 */
export const LegalService: GenService<{
  /**
   * Every document, with its version in effect and any draft. Drafts and
   * retired documents are listed for staff only.
   *
   * @generated from rpc console.admin.v1.LegalService.ListLegalDocuments
   */
  listLegalDocuments: {
    methodKind: "unary";
    input: typeof ListLegalDocumentsRequestSchema;
    output: typeof ListLegalDocumentsResponseSchema;
  },
  /**
   * One document and every version of it, newest first.
   *
   * @generated from rpc console.admin.v1.LegalService.GetLegalDocument
   */
  getLegalDocument: {
    methodKind: "unary";
    input: typeof GetLegalDocumentRequestSchema;
    output: typeof GetLegalDocumentResponseSchema;
  },
  /**
   * A new document, with an empty draft. `key` is lower case letters, digits
   * and underscores, unique, and never changes. Audited
   * `legal.document_created`.
   *
   * @generated from rpc console.admin.v1.LegalService.CreateLegalDocument
   */
  createLegalDocument: {
    methodKind: "unary";
    input: typeof CreateLegalDocumentRequestSchema;
    output: typeof CreateLegalDocumentResponseSchema;
  },
  /**
   * Write the document's draft, making one when there is none. Markdown the
   * console cannot draw is INVALID_ARGUMENT with the line and what is not
   * supported. Not audited: a draft is shown to no one.
   *
   * @generated from rpc console.admin.v1.LegalService.SaveLegalDraft
   */
  saveLegalDraft: {
    methodKind: "unary";
    input: typeof SaveLegalDraftRequestSchema;
    output: typeof SaveLegalDraftResponseSchema;
  },
  /**
   * Throw the draft away.
   *
   * @generated from rpc console.admin.v1.LegalService.DeleteLegalDraft
   */
  deleteLegalDraft: {
    methodKind: "unary";
    input: typeof DeleteLegalDraftRequestSchema;
    output: typeof DeleteLegalDraftResponseSchema;
  },
  /**
   * Markdown as the device will draw it, for the editor's preview. Changes
   * nothing.
   *
   * @generated from rpc console.admin.v1.LegalService.PreviewLegalMarkdown
   */
  previewLegalMarkdown: {
    methodKind: "unary";
    input: typeof PreviewLegalMarkdownRequestSchema;
    output: typeof PreviewLegalMarkdownResponseSchema;
  },
  /**
   * How many people publishing the draft this way would ask, out of
   * everyone who signs in. Changes nothing.
   *
   * @generated from rpc console.admin.v1.LegalService.PreviewLegalPublish
   */
  previewLegalPublish: {
    methodKind: "unary";
    input: typeof PreviewLegalPublishRequestSchema;
    output: typeof PreviewLegalPublishResponseSchema;
  },
  /**
   * The draft becomes the next version, fixed from now on. The first
   * version of a document always asks everyone. Audited
   * `legal.version_published` in the staff trail.
   *
   * @generated from rpc console.admin.v1.LegalService.PublishLegalVersion
   */
  publishLegalVersion: {
    methodKind: "unary";
    input: typeof PublishLegalVersionRequestSchema;
    output: typeof PublishLegalVersionResponseSchema;
  },
  /**
   * Asked of no one from now on; its versions and acceptances stay.
   * Audited `legal.document_retired`.
   *
   * @generated from rpc console.admin.v1.LegalService.RetireLegalDocument
   */
  retireLegalDocument: {
    methodKind: "unary";
    input: typeof RetireLegalDocumentRequestSchema;
    output: typeof RetireLegalDocumentResponseSchema;
  },
  /**
   * Gone from the console: no list, page, sign-in or public page shows it,
   * and its key is free again. Its versions and everyone's acceptances of
   * them stay, as does the audit trail. `confirm_key` must be its key.
   * Audited `legal.document_deleted` in the staff trail.
   *
   * @generated from rpc console.admin.v1.LegalService.DeleteLegalDocument
   */
  deleteLegalDocument: {
    methodKind: "unary";
    input: typeof DeleteLegalDocumentRequestSchema;
    output: typeof DeleteLegalDocumentResponseSchema;
  },
  /**
   * An organization's custom agreement, if it has one, and the ones before
   * it.
   *
   * @generated from rpc console.admin.v1.LegalService.GetOrgAgreement
   */
  getOrgAgreement: {
    methodKind: "unary";
    input: typeof GetOrgAgreementRequestSchema;
    output: typeof GetOrgAgreementResponseSchema;
  },
  /**
   * Record the organization's agreement. One that stands is replaced in the
   * same step, so the organization is never uncovered. Audited
   * `legal.agreement_set` in the organization's trail and the staff trail.
   *
   * @generated from rpc console.admin.v1.LegalService.SetOrgAgreement
   */
  setOrgAgreement: {
    methodKind: "unary";
    input: typeof SetOrgAgreementRequestSchema;
    output: typeof SetOrgAgreementResponseSchema;
  },
  /**
   * How many of the organization's people clearing its agreement would ask.
   *
   * @generated from rpc console.admin.v1.LegalService.PreviewOrgAgreementClear
   */
  previewOrgAgreementClear: {
    methodKind: "unary";
    input: typeof PreviewOrgAgreementClearRequestSchema;
    output: typeof PreviewOrgAgreementClearResponseSchema;
  },
  /**
   * Its people accept MotionSafe's documents at their next full sign-in.
   * Audited `legal.agreement_cleared` in both trails.
   *
   * @generated from rpc console.admin.v1.LegalService.ClearOrgAgreement
   */
  clearOrgAgreement: {
    methodKind: "unary";
    input: typeof ClearOrgAgreementRequestSchema;
    output: typeof ClearOrgAgreementResponseSchema;
  },
  /**
   * Each person of an organization and where they stand on each document.
   *
   * @generated from rpc console.admin.v1.LegalService.ListLegalStanding
   */
  listLegalStanding: {
    methodKind: "unary";
    input: typeof ListLegalStandingRequestSchema;
    output: typeof ListLegalStandingResponseSchema;
  },
  /**
   * The signed-in person's own: each document in effect, and each they have
   * accepted, with the version they accepted and its text. The documents are
   * not public; this is where a person reads what they agreed to.
   *
   * @generated from rpc console.admin.v1.LegalService.GetMyLegalDocuments
   */
  getMyLegalDocuments: {
    methodKind: "unary";
    input: typeof GetMyLegalDocumentsRequestSchema;
    output: typeof GetMyLegalDocumentsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_console_admin_v1_legal, 0);

